import React from 'react'
import './App.css'
import About from './components/about/About'
import Contact from './components/contact/Contact'
import Footer from './components/footer/Footer'
import Header from './components/header/Header'
import Home from './components/home/Home'
import Qualification from './components/qualification/Qualification'
import ScrollUp from './components/scrollup/ScrollUp'
import Services from './components/codingprofiles/Services'
import Skills from './components/skills/Skills'

import Work from './components/work/Work'

const App = () => {
  return (
    <div>
      <Header />

      <main className="main">
        <Home />
        <About />
        <Skills />
        <Services />
        <Qualification />
        <Work />
        {/*<Testimonials />*/}
        <Contact />
      </main>

      <Footer />
      <ScrollUp />
    </div>
  )
}

export default App